var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.297,
    height: 33.297,
    viewBox: "0 0 33.297 33.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165673",
    "data-name": "Grupo 165673",
    transform: "translate(-2588.167 2034.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98011",
    "data-name": "Trazado 98011",
    d: "M37.3,20.749A16.649,16.649,0,1,0,18.047,37.3v-11.7H13.82V20.748h4.227V17.059c0-4.2,2.485-6.517,6.289-6.517a25.463,25.463,0,0,1,3.727.327v4.122h-2.1a2.413,2.413,0,0,0-2.712,2.617v3.141h4.617l-.738,4.841H23.25V37.3A16.722,16.722,0,0,0,37.3,20.749Z",
    transform: "translate(2584.167 -2038.956)",
    fill: "#224a8d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.7f437d8936ae40c2d09f63f9044a215c.svg";
export { ForwardRef as ReactComponent };